import { TwilioSetupStep } from "../../../components/SetupDialog/plan-dialogs/steps";
import type { SetupStepComponentProps } from "../../types";

export const TwilioSetupStepAdapter = ({
  selectedIntegrationNames,
  onComplete,
  onBack,
  onSkip,
}: SetupStepComponentProps) => (
  <TwilioSetupStep
    selectedIntegrationNames={selectedIntegrationNames}
    onContinue={onComplete}
    onBack={onBack}
    onSkip={onSkip}
  />
);
